
import Paypal from "../../../assets/outline/Paypal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PaypalIcon({ className, dataTestid = "PaypalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Paypal data-testid={dataTestid} className={classes} {...rest} />
  );
}
